module.exports = __webpack_public_path__ + "img/202602_05.9586e7b5.png";